export default __webpack_public_path__ + "static/media/Rajwada-Indore.d0e6db1f.jpg";